<template>
    <div class="account md-layout md-alignment-top-center">
        <md-card class="md-layout-item md-size-65">
            <md-card-header>
                <md-card-header-text>
                    <div class="md-title">{{account.name}}</div>
                    <template v-if="account.type === 'Other'">
                        <div v-for="user in users" :key="user.ID" class="md-subhead">
                            {{user.name}}
                        </div>

                    </template>
                </md-card-header-text>
                <md-menu md-size="big" md-direction="bottom-end">
                    <md-button class="md-icon-button" md-menu-trigger>
                        <md-icon>more_vert</md-icon>
                    </md-button>

                    <md-menu-content>
                        <md-menu-item v-if="account.type === 'Student'" @click="limitModalActive = true">
                        <span>Update Limit</span>
                        <md-icon>edit</md-icon>
                        </md-menu-item>

                        <md-menu-item v-if="!account.archived" :disabled="account.balance != 0" @click="archiveModalActive = true">
                        <span>Archive Account</span>
                        <md-icon>archive</md-icon>
                        </md-menu-item>
                        <md-menu-item v-else-if="!account.permanentArchive" @click="activateAccount">
                        <span>Re-Activate Account</span>
                        <md-icon>unarchive</md-icon>
                        </md-menu-item>
                        <md-menu-item v-if="account.type === 'Other'" @click="showAuthDialog">
                        <span>Add Authorized User</span>
                        <md-icon>supervisor_account</md-icon>
                        </md-menu-item>
                    </md-menu-content>
                </md-menu>
            </md-card-header>
            <md-card-content>
                <h1 class="md-headline text-center">
                    <span>Current Balance: {{account.balance | currency}}</span>
                    <md-badge :md-content="account.deposits">
                        <md-button class="md-icon-button" disabled>
                            <md-icon>arrow_downward</md-icon>
                        </md-button>
                    </md-badge>
                    <md-badge :md-content="account.withdrawls">
                        <md-button class="md-icon-button" disabled>
                            <md-icon>arrow_upward</md-icon>
                        </md-button>
                    </md-badge>
                </h1>
                <md-divider class="md-inset"></md-divider>
                <div v-if="!account.archived">
                    <div class="md-layout md-alignment-center-center">
                        <md-field class="md-layout-item md-size-40">
                            <label>Amount</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="depositAmount"></md-input>
                        </md-field>
                        <md-button :disabled="!validAmount(depositAmount)" @click="updateAccount(depositAmount)">Deposit</md-button>
                    </div>
                    <div class="md-layout md-alignment-center-center">
                        <md-field class="md-layout-item md-size-40" :class="{'md-invalid': withdrawlError}">
                            <label>Amount</label>
                            <span class="md-prefix">$</span>
                            <md-input v-model.number="withdrawlAmount"></md-input>
                            <span v-if="account.type === 'student'" class="md-helper-text">Limit: {{account.limit | currency}}</span>
                            <span v-if="withdrawlError == 'overBalance'" class="md-error">Amount is more than the current account balance</span>
                            <span v-else-if="withdrawlError == 'overLimit'" class="md-error">Note from the Dean is needed to withdraw more than {{account.limit | currency}}</span>
                        </md-field>
                        <md-button
                        :class="{'red': withdrawlError}" 
                        :disabled="!validAmount(withdrawlAmount)"
                        @click="updateAccount(-withdrawlAmount)">Withdraw</md-button>
                    </div>
                </div>
                
            </md-card-content>
        </md-card>
        <md-card class="md-layout-item md-size-65">
            <md-card-header>
                <div class="md-title">Transactions</div>
            </md-card-header>
            <md-card-content>
                 <md-table>
                        <md-table-row>
                            <md-table-head>Date</md-table-head>
                            <md-table-head>Change</md-table-head>
                            <md-table-head>Balance</md-table-head>
                        </md-table-row>
                        <md-table-row v-for="transaction of pagedTransactions" :key="transaction['.key']">
                            <md-table-cell>{{transaction.timestamp | date}}</md-table-cell>
                            <md-table-cell :class="{'green': transaction.amount > 0, 'red': transaction.amount < 0}">{{transaction.amount | currency}}</md-table-cell>
                            <md-table-cell :class="{'green': transaction.amount > 0, 'red': transaction.amount < 0}">{{transaction.accountBalance | currency}}</md-table-cell>
                        </md-table-row>
                    </md-table>
                    <paginator v-on:paginated-list="updateTable" :list="transactions"></paginator>
            </md-card-content>
        </md-card>
        <md-dialog-confirm
            :md-active.sync="archiveModalActive"
            md-title="Archive Account?"
            md-content="Once this account is archived it will no longer appear on the accounts page, but all previous transactions will still appear in the reporting."
            md-confirm-text="Confirm"
            md-cancel-text="Cancel"
            @md-cancel="archiveModalActive = false"
            @md-confirm="archiveAccount" />
        <md-dialog :md-active.sync="limitModalActive">
            <md-dialog-title>Change Withdrawl Limit</md-dialog-title>
            <div class="md-layout md-alignment-top-center">
                <div class="md-layout-item md-size-80">
                    <md-field :class="{'md-invalid': localLimit <= 0}">
                        <label>Limit</label>
                        <span class="md-prefix">$</span>
                        <md-input v-model.number="localLimit"></md-input>
                        <span class="md-error">Limit must be positive</span>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button :disabled="localLimit <=0" @click="updateLimit">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog class="md-layout-item md-size-50" :md-active.sync="authorizedUserModelActive" :md-click-outside-to-close="false">
            <md-dialog-title>Add Authorized User</md-dialog-title>
            <div class="md-layout md-alignment-top-center">
                <div class="md-layout-item md-size-80">
                    <md-field>
                        <label>Choose User</label>
                        <md-select v-model="selectedStaff" multiple>
                            <md-option v-for="s in staff" :key="s.ID" :value="s.ID">{{s.name}}</md-option>
                        </md-select>
                    </md-field>
                </div>
            </div>
            <md-dialog-actions>
                <md-button :disabled="selectedStaff.length === 0" @click="updateAuthUsers">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    <md-snackbar md-position="left" :md-duration="5000" :md-active.sync="showSnackbar">
        <span>{{snackBarMessage}}</span>
    </md-snackbar>
    </div>
</template>

<script>
import Paginator from '@/components/Paginator.vue'
import {db} from '@/db';
import { mapGetters } from 'vuex';
export default {
  name: "Account",
  props: {
    account: Object,
    transactions: Array
  },
  data:()=>({
      depositAmount:null,
      withdrawlAmount: null,
      pagedTransactions: [],
      archiveModalActive: false,
      limitModalActive: false,
      authorizedUserModelActive: false,
      showSnackbar: false,
      snackBarMessage: "Account archived",
      localLimit: 0,
      selectedStaff: []
  }),
  
  components: {
      Paginator
  },
  computed:{
      withdrawlError: function(){
          if(this.withdrawlAmount > this.account.balance){
              return 'overBalance'
          }
          if(this.account.type === 'Student' && (this.withdrawlAmount + this.weekWithdrawl) > this.account.limit){
              return 'overLimit'
          }
          return false
      },
      accountRef: function(){
          
          return db.ref(`bankAccounts/${this.account.ID}`);
      },
      weekWithdrawl: function(){
          const today = new Date();
          const startDate = new Date();
          startDate.setTime(today.getTime() - today.getDay() * 24 * 3600 * 1000);
          const startString = startDate.toIsoString();
          const endString = today.toIsoString();
          let withdrawlAmount = 0; 
          this.transactions
            .filter(t => t.timestamp >= startString && t.timestamp <= endString)
            .forEach(t => {
                if(t.amount < 0){
                    withdrawlAmount -= t.amount; 
                }
            });
            return withdrawlAmount;
      },
      users: function(){
          if(this.account.type === 'Other'){
              let users = [];
              for(let user in this.account.authorizedUsers){
                  users.push(this.account.authorizedUsers[user]);
              }
              return users;
          }
          return []
      },
      ...mapGetters(['staff']),
  },
  methods:{
      updateTable(event){
          this.pagedTransactions = event;
      },
      archiveAccount(){
          this.archiveModalActive = false;
          this.accountRef.update({archived: true})
          this.snackBarMessage = "Account archived";
          this.showSnackbar = true;
      },
      updateLimit(){
          this.limitModalActive = false;
          this.accountRef.update({limit: this.localLimit})
          
      },
      showAuthDialog(){
          this.authorizedUserModelActive = true;
          this.selectedStaff = this.users.slice().map(s => s.ID);
      },
      updateAuthUsers(){
          this.authorizedUserModelActive = false;
          let update = {};
          this.selectedStaff.forEach(s => {
              let i = this.staff.map(s => s.ID).indexOf(s);
              let obj = this.staff[i];
              delete obj['.key']
              update[`bankAccounts/${this.account.ID}/authorizedUsers/${s}`] = obj;
          })
          db.ref('/').update(update);
      },
      activateAccount(){
          this.accountRef.update({archived: false});
          this.snackBarMessage = "Account re-activated";
          this.showSnackbar = true;
      },
      updateAccount(change){
          let transaction = {
              amount:change,
              timestamp: new Date().toIsoString(),
              accountBalance: this.account.balance + change,
              ID: this.account.ID,
              accountName: this.account.name
              };
            
          this.$emit('new-transaction', transaction);
          this.withdrawlAmount = null;
          this.depositAmount = null;
      },
      validAmount(amount){
          return amount > 0
      }
  },
  created(){
      this.localLimit = this.account.limit
  }
};
</script>
<style lang="scss" scoped>
    span.counts{
        text-align: center;
        margin-top: 1em
    }
    .md-card{
        margin-bottom: 2em;
    }
</style>


